import { useEffect } from "react";
import { getPlatform } from "utils/config";
import { useFrontEndLoggerMutation } from "redux/reduxAPI";

export const useUtmTracker = () => {
  const params = new URLSearchParams(window.location.search);
  const [logError] = useFrontEndLoggerMutation();
  useEffect(() => {
    let creatorSource = {};
    try {
      creatorSource = JSON.parse(localStorage.getItem("creatorSource"));
    } catch (error) {
      // do nothing
    }
    if (creatorSource && Object.keys(creatorSource).length > 0) return;
    const sources = {};
    const utm_tags = ["utm_source", "utm_campaign", "utm_medium"];
    for (const tag of utm_tags) {
      const tagValue = params.get(tag);
      if (tagValue) {
        sources[tag] = tagValue;
      }
    }
    sources["device_platform"] = getPlatform(logError);
    localStorage.setItem("creatorSource", JSON.stringify(sources));
  }, [logError]);
};
